export default {
    startCheckingServerVersion: function(appInfo){
        // we don't need to stop, it should run while the app is running
        window.setInterval(() => appInfo.updateAppVersion(), 60 * 1000);
    },

    reloadAppIfNeeded: function(runningVersion, serverVersion){
        if(serverVersion && serverVersion !== runningVersion){
            window.console.log('version changed, will reload', runningVersion, serverVersion)
            window.location.reload();
        }
    }
}
